import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

/*  date format  */
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
const moment = _moment;

import { FilterBoxService } from '../../../services/filter-box.service';
import { GenericDataSource } from '../../../models/generic-data-source';
import { MY_DATE_FORMATS, FilterStructure, GeneralFilterComponent } from '../../../models/generic-filter';

@Component({
  selector: 'app-pratiche-filter',
  templateUrl: './pratiche-filter.component.html',
  styleUrls: ['./pratiche-filter.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS},
  ],
})
export class PraticheFilterComponent extends GeneralFilterComponent implements OnInit {
    emissioni: any[];
    emissioniEmpty: boolean;
    emissioniSelectedControl: FormControl;

    activeFlow: any[];
    flowContent: any = null;

    nextStates: any[] = [];
    canForward: boolean = false;

    constructor(private adapter: DateAdapter<any>, private filterBoxService: FilterBoxService){
        super();
        this.dataSource = new GenericDataSource(this.filterBoxService);
        this.adapter.setLocale('it');
    }

    ngOnInit(){
        this.resetContext = false;
        this.filterFormGroup = new FormGroup({
            emissioniSelectedControl: new FormControl({ value: "", disabled: false, }),
            statoSelectedControl: new FormControl({ value: "", disabled: false, }),
            nominativoControl: new FormControl({ value: "", disabled: false, }),
            genericFilterSelectedControl: new FormControl({ value: "", disabled: false, }),
            scadenzaEntroControl: new FormControl({ value: "", disabled: false, }),
        });
        let filterFormGroup = this.filterFormGroup.getRawValue();
        for(let key in filterFormGroup){
            if(filterFormGroup.hasOwnProperty(key)){
                switch(key){
                    case 'genericFilterSelectedControl':
                        this.filterFormGroup.get(key).valueChanges.subscribe(() => {
                            let val = this.filterFormGroup.get('genericFilterSelectedControl').value;
                            if(val == 'scadenza_entro'){
                                this.filterFormGroup.get('scadenzaEntroControl').enable();
                            }else{
                                this.clearField("scadenzaEntroControl");
                                this.filterFormGroup.get('scadenzaEntroControl').disable();
                            }
                            if(!this.resetContext)
                                this.updateFiltersMap();
                        });
                        break;
                    case 'statoSelectedControl':
                        this.filterFormGroup.get(key).valueChanges.subscribe(() => {
                            this.idStatoChanged(this.filterFormGroup.get(key).value);
                            if(!this.resetContext)
                                this.updateFiltersMap();
                        });
                        break;
                    default:
                        this.filterFormGroup.get(key).valueChanges.subscribe(() => {
                            if(!this.resetContext)
                                this.updateFiltersMap();
                        });
                }
                //console.log("CMP|PRATICHE-FILTER - filterFormGroup", key, val);
            }
        }
        this.resetFilters();
    }

    ngOnChanges(changes: any){
        //console.log('CMP|PRATICHE-FILTER - CHANGE', changes);
        if(changes.dataArraySource){
            //console.log('CMP|PRATICHE-FILTER - CHANGE dataArraySource', changes.dataArraySource);
            this.resetFilters();
        }
        if(changes.filterMap){
            //console.log('CMP|PRATICHE-FILTER - CHANGE filterMap', this.filterMap);
            this.resetFilters();
        }
        if(changes.parametriString){
            //console.log('CMP|PRATICHE-FILTER - CHANGE parametriString');
            this.updateParametri();
        }
    }

    generateFilterMap(){
        let filterStructureLocal: any = null;
        super.resetFilterMap();
        let emissioniSelectedValue = "";
        let statoSelectedValue = "";
        let nominativoValue = "";
        let genericFilterSelectedValue = "";
        let scadenzaEntroValue = null;
        let scadenzaEntroDate = "";

        if(this.filterFormGroup){
            emissioniSelectedValue = this.filterFormGroup.get('emissioniSelectedControl').value;
            statoSelectedValue = this.filterFormGroup.get('statoSelectedControl').value;
            nominativoValue = this.filterFormGroup.get('nominativoControl').value;
            genericFilterSelectedValue = this.filterFormGroup.get('genericFilterSelectedControl').value;
            scadenzaEntroValue = this.filterFormGroup.get('scadenzaEntroControl').value;
        }
        if(scadenzaEntroValue){
            scadenzaEntroDate = scadenzaEntroValue.format('YYYY-MM-DD');
        }

        filterStructureLocal = { "name": "emissioniSelected", "value": emissioniSelectedValue, "itemKey": "emissione_id", "type": "number", "op": "=" };
        super.setFilterStructure("emissioniSelected", filterStructureLocal);

        filterStructureLocal = { "name": "statoSelected", "value": statoSelectedValue, "itemKey": "stato_id", "type": "number", "op": "=" };
        super.setFilterStructure("statoSelected", filterStructureLocal);

        filterStructureLocal = { "name": "nominativo", "value": nominativoValue, "itemKey": "nominativo", "type": "string", "op": "=" };
        super.setFilterStructure("nominativo", filterStructureLocal);

        filterStructureLocal = { "name": "genericFilterSelected", "value": genericFilterSelectedValue, "type": "string", "op": "=" };
        super.setFilterStructure("genericFilterSelected", filterStructureLocal);

        filterStructureLocal = {
            "name": "scadenza",
            "object": scadenzaEntroValue,
            "value": scadenzaEntroDate,
            "itemKey": "",
            "filterKey": "",
            "type": "date",
            "op": "<=",
        };
        super.setFilterStructure("ScadenzaEntro", filterStructureLocal);
    }

    updateFiltersMap(){
        //console.log("CMP|PRATICHE-FILTER - updateFiltersMap", this.filterMap);
        this.generateFilterMap();
        super.find();

        let trovato = (this.filterMap.get('rapportoStileRadio')) ? this.filterMap.get('rapportoStileRadio') : null;
        //console.log("CMP|PRATICHE-FILTER - rapportoStileRadio trovato", trovato);
        if(trovato){
            this.groupByCommand('CMP|PRATICHE-FILTER - rapportoStileRadio', trovato.value);
        }
        //console.log("CMP|PRATICHE-FILTER - updateFiltersMap", this.filterMap);
    }

    resetFilters(){
        let filterMapLocal = super.getFilterMap();
        //console.log('CMP|PRATICHE-FILTER - RESET FILTER', filterMapLocal);
        this.resetContext = true;
        let filterFormGroup = this.filterFormGroup.getRawValue();
        for(let key in filterFormGroup){
            if(filterFormGroup.hasOwnProperty(key)){
                this.clearField(key, false);
            }
        }
        this.updateFiltersMap();
        this.resetContext = false;
        filterMapLocal = super.getFilterMap();
        //console.log('CMP|PRATICHE-FILTER - RESET FILTER', filterMapLocal);
        this.filterMap = filterMapLocal;
        super.find();
    }

    clearField(nameField: string, updateFilters: boolean = true){
        //console.log('CMP|PRATICHE-FILTER - clearField', nameField, updateFilters);
        switch(nameField){
            case "emissioniSelectedControl":{
                this.filterFormGroup.get('emissioniSelectedControl').setValue("");
                break;
            }
            case "statoSelectedControl":{
                this.filterFormGroup.get("statoSelectedControl").setValue("");
                break;
            }
            case "nominativoControl":{
                this.filterFormGroup.get("nominativoControl").setValue("");
                break;
            }
            case "genericFilterSelectedControl":{
                this.filterFormGroup.get("genericFilterSelectedControl").setValue("");
                break;
            }
            case "scadenzaEntroControl":{
                this.filterFormGroup.get("scadenzaEntroControl").setValue("");
                break;
            }
        }
        if(updateFilters){
            this.updateFiltersMap();
        }
    }

    updateParametri(){
      super.updateParametri();
      //console.log('CMP|PRATICHE-FILTER - UPDATE PARAMETRI', this.parametri);
      if(!this.parametri.emissioni){
          this.emissioni = [];
      }else{
          this.emissioni = this.parametri.emissioni;
      }
      this.emissioniEmpty = (this.emissioni.length) ? false : true;

      let localEmissioneSelected = null;
      //console.log('CMP|PRATICHE-FILTER - CHANGE EMISSIONI', changes.parametri.emissioni);
      if(this.filterFormGroup){
          localEmissioneSelected = this.filterFormGroup.get('emissioniSelectedControl').value;
      }
      //console.log('CMP|PRATICHE-FILTER - CHANGE EMISSIONI localEmissioneSelected', localEmissioneSelected);

      //console.log('CMP|PRATICHE-FILTER - CHANGE flowContent:', this.parametri.activeFlow);
      if (this.parametri.activeFlow){
          this.flowContent = this.parametri.activeFlow['contenuto'];
      }
      //console.log('CMP|PRATICHE-FILTER - CHANGE flowContent:', this.flowContent);
      this.updateFiltersMap();
    }

    /* funzioni accessorie a filtrare le pratiche */
    checkNextState(){
      this.canForward = false;
          this.updateFiltersMap();
      this.nextStates = [];
      let nextStatesId = this.flowContent.workflow.connections[this.filterFormGroup.get("statoSelectedControl").value];
      //console.log('CMP|PRATICHE-FILTER - nextStatesId', nextStatesId);
      if (nextStatesId){
        for (let state of this.flowContent.workflow.states){
          if(nextStatesId.indexOf(state.id) != -1){
            let settings = this.flowContent.stateSettings[state.id];
            if (true){ // verifica dei filtri
              this.nextStates.push(state);
            }
          }
        }
        this.canForward = true;
      }
	}

    callbackExternCommands(dataCommand: any){
        let eventObject = {
            "type": "action",
            "data": dataCommand,
        };
        this.filterBoxGenericEmitter.emit(eventObject);
    }

    groupByCommand(groupByKey: any, groupByType: any){
        let eventObject = {
            "type": "groupBy",
            "data": {
                key: groupByKey,
                value: groupByType,
            },
        };
        console.log("CMP|PRATICHE-FILTER - groupBy", eventObject);
        this.filterBoxGenericEmitter.emit(eventObject);
    }

    findEmissione(element: any){
        //console.log("CMP|PRATICHE-FILTER - emissioniSelected findEmissione", element, this);
        return element.id == this;
    }
}
